import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const RowHeader_ = styled.div({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width: '100%',
  border: `1px solid ${v.borderGray}`,
  height:'3rem',
  fontWeight:'bold',
  fontSize:'1.1rem'
})

export const RowHeader = styled.div({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width: '100%',
  border: `1px solid ${v.borderGray}`,
  borderLeftWidth:0,
  height:'3rem',
  fontWeight:'bold',
  fontSize:'1.1rem'
})

export const RowData_ = styled.div({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width: '100%',
  border: `1px solid ${v.borderGray}`,
  borderTopWidth:0,
  fontWeight:'bold',
  '>div':{
    marginRight:1,
    marginLeft:1
  },
  'div .fieldRow':{
    marginBottom:0,
    borderColor:'#fff'
  },
  '.disabled input':{
    borderColor:'#fff !important'
  },
})

export const RowData = styled.div({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width: '100%',
  border: `1px solid ${v.borderGray}`,
  borderLeftWidth:0,
  borderTopWidth:0,
  '>div':{
    marginRight:1
  },
  'div .fieldRow':{
    marginBottom:1
  },
  'input, textarea, .fieldInput input':{
    borderColor:'#fff !important'
  }
})

export const RowNF = styled.div({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width: '100%',
  border: `1px solid ${v.borderGray}`,
  borderTopWidth:0,
  height:'3rem',
  fontStyle:'italic',
  color:'#888888'
})